import { useState, useEffect, useCallback } from 'react'
import pb from '@/lib/pb'
import type { TUser } from '@/types'

export function useAuth() {
  const [user, setUser] = useState<TUser | null>(
    pb.authStore.isValid ? (pb.authStore.record as unknown as TUser | null) : null
  )
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const unsub = pb.authStore.onChange(() => {
      setUser(pb.authStore.isValid ? (pb.authStore.record as unknown as TUser | null) : null)
    })
    return () => unsub()
  }, [])

  // OAuth login (Google)
  const loginWithGoogle = useCallback(async () => {
    setIsLoading(true)
    try {
      await pb.collection('users').authWithOAuth2({ provider: 'google' })
    } finally {
      setIsLoading(false)
    }
  }, [])

  // Password login (users collection only — superuser is for PB admin dashboard only)
  const login = useCallback(async (email: string, password: string) => {
    setIsLoading(true)
    try {
      await pb.collection('users').authWithPassword(email, password)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const logout = useCallback(() => {
    pb.authStore.clear()
  }, [])

  return {
    user,
    isAuthenticated: pb.authStore.isValid,
    isLoading,
    login,
    loginWithGoogle,
    logout,
  }
}
